(() => {
  const S = window.BlsColorSwatchesShopify;
  if (!S) return;

  const origSwap = S.swapProduct;

  // Swatch tổ hợp: tra variant theo data-variant-id thay vì theo màu
  S.swapProduct = function (productTarget) {
    const active = productTarget.querySelector(".bls__option-swatch-js.active");
    if (!active || !active.dataset.variantId) {
      return origSwap.call(this, productTarget);
    }
    const variantData = JSON.parse(
      productTarget.querySelector(".productinfo").textContent
    );
    const variantQtyData = JSON.parse(
      productTarget.querySelector(".productVariantsQty").textContent
    );
    const currentVariant = variantData.find(
      (v) => String(v.id) === active.dataset.variantId
    );

    this.toggleAddButton(true, "", productTarget);
    if (!currentVariant) {
      this.setUnavailable(productTarget);
      return;
    }

    // renderProductInfo gốc gộp số lượng theo option1 (màu).
    // Đổi option của mỗi variant thành id để nó tính riêng từng variant.
    const qtyByVariant = variantQtyData.map((q) => ({
      ...q,
      option: String(q.id),
    }));
    const variantForInfo = { ...currentVariant, option1: String(currentVariant.id) };

    this.updatePrice(currentVariant, productTarget);
    this.updateMedia(currentVariant, productTarget);
    this.renderProductInfo(
      variantForInfo,
      qtyByVariant,
      productTarget,
      active.dataset.color
    );
  };

  // Ảnh lớn: ưu tiên ảnh variant, không có thì dùng data-image của ô swatch
  S.updateMedia = function (currentVariant, productTarget) {
    if (!currentVariant) return;
    const active = productTarget.querySelector(".bls__option-swatch-js.active");
    const src =
      currentVariant.featured_media?.preview_image?.src || active?.dataset.image;
    if (!src) return;
    setTimeout(() => {
      const img = productTarget.querySelector(".bls__product-main-img img");
      if (!img) return;
      img.removeAttribute("srcset");
      img.setAttribute("src", src);
    }, 200);
  };

  // Nút thêm giỏ nhanh: thêm đúng variant của ô đang chọn
  // (QuickBuy gốc so khớp theo màu nên với tổ hợp sẽ luôn mở quickview)
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(".bls__js-addtocart");
      if (!btn) return;
      const card = btn.closest(".bls__product-item");
      const active = card?.querySelector(
        ".bls__option-swatch-js.active[data-variant-id]"
      );
      const qb = btn.closest("quick-buy");
      if (!active || !qb || !qb.miniCart) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const sticky = document.getElementById("sticky-header");
      if (sticky) {
        sticky.style.display = "block";
      }

      btn.classList.add("btn-loading");
      if (!btn.querySelector(".loader-icon")) {
        const loader = document.createElement("div");
        loader.classList.add("loader-icon");
        btn.appendChild(loader);
      }
      const sections = qb.miniCart.getSectionsToRender().map((s) => s.id);
      qb.fetchAddCart(active.dataset.variantId, 1, sections, btn);
    },
    true
  );
})();